document.addEventListener('DOMContentLoaded', function() {
  const openButton = document.getElementById('open-facets');
  const drawer = document.getElementById('facet-drawer');
  const closeButton = drawer?.querySelector('.drawer-close');
  const drawerOverlay = drawer?.querySelector('.drawer-overlay');
  const drawerContent = drawer?.querySelector('.facet-drawer-content');

  if (!drawer || !openButton) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.style.visibility = 'visible';
    document.body.classList.add('overflow-hidden');
  }

  function closeDrawer(e) {
    e?.preventDefault();
    drawer.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    
    // Wait for transition to complete before removing visibility
    drawerContent.addEventListener('transitionend', () => {
      if (!drawer.classList.contains('is-open')) {
        drawer.style.visibility = 'hidden';
      }
    }, { once: true });
  }

  // Outside click handler
  function handleClickOutside(e) {
    if (drawer.classList.contains('is-open') && 
        !drawerContent.contains(e.target) && 
        !openButton.contains(e.target)) {
      closeDrawer(e);
    }
  }

  openButton.addEventListener('click', openDrawer);
  document.addEventListener('mousedown', handleClickOutside);
  
  // Close button click
  if (closeButton) {
    closeButton.addEventListener('click', closeDrawer);
  }

  // Overlay click
  if (drawerOverlay) {
    drawerOverlay.addEventListener('click', closeDrawer);
  }

  // Escape key press
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer(e);
    }
  });
});
